/** Agent name used for the orchestrator (tools running outside any sub-agent). */
export const ORCHESTRATOR_AGENT = 'os' as const;

/**
 * Map internal agent keys to human-friendly display names.
 *
 * Live agents: cam, search, image_gen, 3d_gen (process nodes) plus the
 * orchestrator. Everything under "historical" belongs to retired agents that
 * can still appear in persisted conversations' agent boundaries — keep them
 * so old threads render with proper names.
 */
export const AGENT_DISPLAY_NAMES: Record<string, string> = {
  os: 'Planning',
  cam: 'Aibuild CAM',
  search: 'Search',
  image_gen: 'Image Generation',
  '3d_gen': '3D Generation',
  // historical
  freecad: 'FreeCAD',
  cad_convert: 'CAD Convert',
  fusion_desktop: 'Fusion',
  blender_desktop: 'Blender',
  blender_headless: 'Blender',
  blender: 'Blender',
  cadquery: 'CadQuery',
  drawing_to_3d: 'Engineering Drawing',
  vectorize_scan: 'Vectorize Scan',
  fusion: 'Fusion',
  pymeshlab: 'PyMeshLab',
  rhino_desktop: 'Rhino',
  rhino_compute: 'Rhino Compute',
  rhino: 'Rhino',
  catia: 'CATIA',
  solidworks: 'SolidWorks',
  abaqus: 'Abaqus',
  fets: 'Aibuild FETS',
  prusaslicer: 'PrusaSlicer',
  cura: 'Cura',
  model_to_2d: 'Model to 2D',
  techdraw: 'Model to 2D',
  paraview: 'ParaView',
  engineering_drawing_interpreter: 'Engineering Drawing Interpreter',
};

export function agentDisplayName(agent: string): string {
  const mapped = AGENT_DISPLAY_NAMES[agent.toLowerCase()];
  if (mapped) return mapped;
  return agent
    .split(/[_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
